module.exports = __webpack_public_path__ + "static/img/changhceng_logo.034fd1e4.png";